import React, { Fragment, useEffect, useState } from "react"
import PropTypes from "prop-types"
import {
  Button,
  Col,
  Label,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  Spinner,
  Container,
  Card,
  CardBody,
  Input,
} from "reactstrap"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Slide } from "react-toastify"
import API from "../../api"
import Select from "react-select"
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"

const AddScheduleEnseignant = props => {
  const [loading, setLoading] = useState(false)
  const [loadingAdd, setLoadingAdd] = useState(true)
  const [enseignantId, setEnseignantId] = useState("")
  const [type, setType] = useState([])
  const [selectType, setSelectType] = useState([])
  const [etatQuanzaine, setEtatQuanzaine] = useState(0)
  const [matiere, setMatiere] = useState([])
  const [selectMatiere, setSelectMatiere] = useState("")
  const [salle, setSalle] = useState([])
  const [selectSalle, setSelectSalle] = useState("")
  const [groupe, setGroupe] = useState([])
  const [selectGroupe, setSelectGroupe] = useState("")
  const [quarts, setQuarts] = useState([])
  const [jours, setJours] = useState([])
  const [modal, setModal] = useState(false)
  const [jourId, setJourId] = useState("")
  const [quartId, setQuartId] = useState("")
  const [enseignantNom, setEnseignantNom] = useState("")
  const [voeuxJour, setVoeuxJour] = useState([])
  const [modalDelete, setModalDelete] = useState(false)
  const [element, setElement] = useState("")
  const [quan, setQuan] = useState(0)
  const [nbrHeure, setNbrHeure] = useState("")
  const [modalUpdate, setModalUpdate] = useState("")
  const [seance, setSeance] = useState("")
  const [salleId, setSalleId] = useState("")
  const [semestre_id, setSemestre_id] = useState("")
  const [modalLigne, setModalLigne] = useState(false)
  const [indexLigne, setIndexLigne] = useState("")
  const [array, setArray] = useState([
    {
      type_matiere: "",
      matiere_id: "",
      group_id: "",
      capacite_salle:"",
      capacite_groupe:"",
      salle_id:"",
      capacite:1,
      nbrHeureSeance:"",
      charge_matiere:"",
    },
  ])
  const [nbrHeureSeance, setNbrHeureSeance] = useState([
    { value: 2, label: "1h" },
    { value: 3, label: "1h:30" },
    { value: 4, label: "2h" },
    { value: 5, label: "2h:30" },
    { value: 6, label: "3h" },
    { value: 7, label: "3h:30" },
    { value: 8, label: "4h" },
  ])
  const [selectNbrHeureSeance, setSelectNbrHeureSeance] = useState("");
  const [tousSalle, setTousSalle] = useState(2)
  const [colture, setColture] = useState("")
  const [capacite, setCapacite] = useState(1)
  var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
  var annee_id = userAuthScolarite.user.annee_id
  var user_id = userAuthScolarite.user.id
  var role_id = userAuthScolarite.user.role_id
  useEffect(async () => {
    var url = window.location.href
    var array = url.split("=")
    var id_semestre = array[1]
    var array1 = id_semestre.split("/")
    var id = array1[0]
    var semestre_id = array1[1]
    setEnseignantId(id)
    setSemestre_id(semestre_id)
    const resE = await API.post("emploi/get_by_id", {
      enseignant_id: id,
      semestre_id: semestre_id,
      annee_id:annee_id
    }).then(resE => {
      setQuarts(resE.data.emploi[0].quarts)
      setJours(resE.data.emploi[0].jours)
      setColture(resE.data.emploi[0].cloture)
      setLoading(true)
    })
    const res = await API.post("emploi/get_type_matiere", {
      annee_id:annee_id,
      enseignant_id: id,
      semestre_id: semestre_id,
    }).then(res => {
      setArray(prev =>
        prev.map(el => ({
          ...el,
          type_matiere: res.data.emploi,   // applique à tous
        }))
      );

      setType(res.data.emploi)
    })
    const resS = await API.post("fiche/fiche_jour", {
      semestre_id: semestre_id,
      enseignant_id: id,
      annee_id:annee_id
    }).then(resS => {
      setEnseignantNom(resS.data.FicheVoeau.enseignant)
      setVoeuxJour(resS.data.FicheVoeau.jour)
    })
  }, [])

  const toggleLigne = indexOfLigne => {
    setModalLigne(!modalLigne)
    setIndexLigne(indexOfLigne)
  }

  const toggleDeleteLigne = () => {
    array.splice(indexLigne, 1)
    setModalLigne(false)
  }

  const open = element => {
    setModalDelete(!modalDelete)
    setElement(element)
  }

  const openModal = async (elle, element) => {
    setModalUpdate(true)
    setSalleId(elle.id_salle)
    setSeance(elle)
    const resS = await API.post("emploi/get_salle_update", {
      seance_id: elle.id_seance
    }).then(resS => {
      setSalle(resS.data.salles)
    })
  }

  const openModal1 = async () => {
    setModalUpdate(false)
    setSelectSalle("")
    setSelectGroupe("")
  }

  const toggle = (element, elem) => {
    setSelectType("")
    setEtatQuanzaine(0)
    setMatiere([])
    setSelectMatiere("")
    setSalle([])
    setSelectSalle("")
    setGroupe([])
    setSelectGroupe("")
    setNbrHeure("")
    setModal(!modal)
    setLoadingAdd(true)
    var jour_id = elem
    var quart_id = element.id_quart
    setJourId(jour_id)
    setQuartId(quart_id)
    setQuan(0)
    setArray([
      {
        matiere_id: "",
        group_id: "",
      },
    ])
    setTousSalle(2)
    setCapacite(1)
  }

  const toggle1 = (element, elem) => {
    setSelectType("")
    setEtatQuanzaine(1)
    setMatiere([])
    setSelectMatiere("")
    setSalle([])
    setSelectSalle("")
    setGroupe([])
    setSelectGroupe("")
    setNbrHeure("")
    setModal(!modal)
    setLoadingAdd(true)
    var jour_id = elem
    var quart_id = element.id_quart
    setJourId(jour_id)
    setQuartId(quart_id)
    setQuan(1)
    setArray([
      {
        matiere_id: "",
        group_id: "",
      },
    ])
    setTousSalle(2)
  }

  const getMatiere = async (e, index) => {
    setSelectType(e)
    setSelectMatiere("")
    setSelectSalle("")
    setSelectGroupe("")
    setNbrHeure("")
    setArray(
      array.map((el, id) =>
        id === index ? Object.assign(el, { type_matiere: e,matiere_id: "" , group_id: ""  ,nbrHeureSeance:"",salle_id:"",capacite_salle:"",capacite_groupe:"",charge_matiere:""}) : el
      )
    )
    const res = await API.post("emploi/get_matiere", {
      type: e.value,
      semestre_id: semestre_id,
      enseignant_id: enseignantId,
      annee_id:annee_id
    }).then(res => {
      setMatiere(res.data.matieres)
    })
  }

  const getGroupe = async (e, index) => {
    setSelectSalle(e)
    setArray(
      array.map((el, id) =>
        id === index ? Object.assign(el, { salle_id: e }) : el
      )
    )
    API.post("salle/get_capacite", {
      salle_id: e.value,
    }).then(resSalle => {
      setArray(
        array.map((el, id) =>
          id === index ? Object.assign(el, { capacite_salle: resSalle.data.Salle }) : el
        )
      )
    })
    const resG = await API.post("emploi/get_group", {
      semestre_id: semestre_id,
      quart_id: quartId,
      jour_id: jourId,
      quan: etatQuanzaine,
      matiere_id: selectMatiere.value,
      type: selectType.value,
      enseignant_id: enseignantId,
      annee_id:annee_id
    }).then(resG => {
      setGroupe(resG.data.groups)
    })
  }

  const getGroupe1 = async (e, index) => {
    setArray(
      array.map((el, id) =>
        id === index ? Object.assign(el, { matiere_id: e , group_id: ""  ,nbrHeureSeance:"",salle_id:"",capacite_salle:"",capacite_groupe:"",charge_matiere:""}) : el
      )
    )
    setSelectMatiere(e)
    setSelectGroupe("")
    setSelectSalle("")
    const resS = await API.post("emploi/get_salle", {
      quart_id: quartId,
      jour_id: jourId,
      semestre_id: semestre_id,
      quan: etatQuanzaine,
      annee_id:annee_id,
      type: selectType.value,
      matiere_id: e.value,

    }).then(resS => {
      setSalle(resS.data.salles)
    })
    const resG = await API.post("emploi/get_group", {
      semestre_id: semestre_id,
      quart_id: quartId,
      jour_id: jourId,
      quan: etatQuanzaine,
      matiere_id: e.value,
      type: selectType.value,
      enseignant_id: enseignantId,
      annee_id: annee_id,
      filterGroupe: 1,

    }).then(resG => {
      setGroupe(resG.data.groups)
    })
    const res = await API.post("seance/get_heure_by_type", {
      matiere_id: e.value,
      type: selectType.value,
    }).then(res => {
      setArray(
        array.map((el, id) =>
          id === index ? Object.assign(el, { charge_matiere: res.data.nb_heure }) : el
        )
      )
      setNbrHeure(res.data.nb_heure)
    })
  }
  const setQuanzaine = async (event, index) => {
    if (event.target.checked === true) {
      setEtatQuanzaine(1)
      setSelectGroupe("")
      setSelectSalle("")

    } else {
      setEtatQuanzaine(0)
      setSelectGroupe("")
      setSelectSalle("")
    }
  }

  const addGroupe = (e, index) => {
    setSelectGroupe(e)
    setArray(
      array.map((el, id) =>
        id === index ? Object.assign(el, { group_id: e ,capacite_groupe: ""}) : el
      )
    )
    API.post("salle/get_capacite_groupe", {
      type: selectType.value,
      group_id: e,
      annee_id
    }).then(resGroup => {
      setArray(
        array.map((el, id) =>
          id === index ? Object.assign(el, { capacite_groupe: resGroup.data.Salle }) : el
        )
      )
    })

  }
  const save = async () => {
    if (selectType == "") {
      toast.error("⛔ Type obligatoire !", {
        containerId: "A",
      })
    } else if (selectMatiere == "") {
      toast.error("⛔ Matière obligatoire !", {
        containerId: "A",
      })
    } else if (selectSalle == "") {
      toast.error("⛔ Salle obligatoire !", {
        containerId: "A",
      })
    } else if (selectGroupe != "") {
      setLoadingAdd(false)
      const resVerif = await API.post("seance/verif_matiere", {
        enseignant_id: enseignantId,
        semestre_id: semestre_id,
        annee_id:annee_id,
        array: array,
        demi_group: etatQuanzaine,
      }).then(resVerif => {
        setLoadingAdd(true)
        if(resVerif.data.errNum == 300){
          toast.error("⛔"+resVerif.data.msg, {
            containerId: "A",
          })
        }else{
          API.post("seance/add", {
            quart_id: quartId,
            jour_id: jourId,
            enseignant_id: enseignantId,
            type: selectType.value,
            quan: etatQuanzaine,
            salle_id: selectSalle.value,
            array: array,
            semestre_id: semestre_id,
            annee_id:annee_id,
            user_id
          }).then(res => {
            setLoadingAdd(true)
            if(res.data.errNum == 403){
              toast.error("⛔"+res.data.msg, {
                containerId: "A",
              })
            }else{
              const resE = API.post("emploi/get_by_id", {
                enseignant_id: enseignantId,
                semestre_id: semestre_id,
                annee_id:annee_id
              }).then(resE => {
                setQuarts(resE.data.emploi[0].quarts)
                setJours(resE.data.emploi[0].jours)
                setModal(false)
              })
            }

          })
        }
      })
    } else {
      toast.error("⛔ Groupe obligatoire !", {
        containerId: "A",
      })
    }
  }

  const edit = async () => {
    if (selectSalle == "") {
      var salle_id = salleId
    } else {
      var salle_id = selectSalle.value
    }
    const res = await API.post("seance/update", {
      seance_id: seance.id_seance,
      salle_id: salle_id,user_id,annee_id
    }).then(res => {
      const resE = API.post("emploi/get_by_id", {
        enseignant_id: enseignantId,
        semestre_id: semestre_id,
        annee_id:annee_id
      }).then(resE => {
        setQuarts(resE.data.emploi[0].quarts)
        setJours(resE.data.emploi[0].jours)
        setModalUpdate(!modalUpdate)
      })
    })
  }

  const deleteSeance = async () => {
    const res = await API.post("seance/delete", {
      array: element,user_id,annee_id
    }).then(res => {
      const resE = API.post("emploi/get_by_id", {
        enseignant_id: enseignantId,
        semestre_id: semestre_id,
        annee_id:annee_id,
        user_id
      }).then(resE => {
        setQuarts(resE.data.emploi[0].quarts)
        setJours(resE.data.emploi[0].jours)
        setModalDelete(!modalDelete)
      })
    })
  }
  const TousSalle = async () => {
    setSelectSalle("")

    setTousSalle(1)
    const res = await API.get("salle/select").then(res => {
      setSalle(res.data.Salle)
    })
  }

  const CheckCapacite = (etat, index) => {
    setArray(
      array.map((el, id) =>
        id === index ? { ...el, capacite: etat } : el
      )
    );
    setCapacite(etat);

  };
  const filterSalle = async () => {
    if(selectMatiere !=""){
      setTousSalle(2)
      const resS = await API.post("emploi/get_salle", {
        semestre_id: semestre_id,
        quart_id: quartId,
        jour_id: jourId,
        quan: etatQuanzaine,
        annee_id:annee_id,
        matiere_id: selectMatiere.value,
        type: selectType.value,
      }).then(resS => {
        setSalle(resS.data.salles)
      })
    }else{
      setTousSalle(1)
      toast.error("⛔ Matière est obligatoire !!", {
        containerId: "A",
      })
    }
  }
  const addLigne = () => {

    let element =  {
      matiere_id: "",
      group_id: "",
      capacite_salle:"",
      capacite_groupe:"",
      salle_id:"",
      capacite:1,
      nbrHeureSeance:"",
      charge_matiere:"",
    }
    setArray([...array, element])
    setTousSalle(2)
  }
  const cloturer = async () => {
    const res = await API.post("emploi/cloturer", {
      enseignant_id: enseignantId,
      semestre_id: semestre_id,
      annee_id: annee_id,
      user_id
    }).then(res => {
      props.history.push("/SchedulesEnseignants")
    })
  }
  const getNbHeureSeance = async (e, index) => {
    setSelectNbrHeureSeance(e)
    setArray(
      array.map((el, id) =>
        id === index ? Object.assign(el, { tousGroupe: 1,nbrHeureSeance: e ,salle_id: "",capacite_salle: "",group_id: "",capacite_groupe: ""}) : el
      )
    )
    const resS = await API.post("emploi/get_salle", {
      quart_id: quartId,
      jour_id: jourId,
      semestre_id: semestre_id,
      quan: etatQuanzaine,
      annee_id:annee_id,
      type: selectType.value,
      matiere_id: selectMatiere.value,
      nb_heure_seance: e.value,
    }).then(resS => {
      setSalle(resS.data.salles)
    })
    const resG = await API.post("emploi/get_group", {
      semestre_id: semestre_id,
      quart_id: quartId,
      jour_id: jourId,
      quan: etatQuanzaine,
      matiere_id: selectMatiere.value,
      type: selectType.value,
      enseignant_id: enseignantId,
      annee_id: annee_id,
      filterGroupe: 1,
      nb_heure_seance: e.value,
    }).then(resG => {
      setGroupe(resG.data.groups)
    })
  }
  const ValiderEmploi = async () => {
    const res = await API.post("emploi/valider", {
      enseignant_id: enseignantId,
      semestre_id: semestre_id,
      annee_id: annee_id,
      user_id,
    }).then(res => {
      props.history.push("/SchedulesEnseignants")
    })
  }


  const parseDroppableId = droppableId => {
    const parts = droppableId.split("-")
    return {
      jour_id: parseInt(parts[1], 10),
      quart_id: parseInt(parts[3], 10),
    }
  }
  const parseDraggableId = draggableId => {
    const parts = draggableId.split("-")
    return {
      jour_id: parseInt(parts[1], 10),
      quart_id: parseInt(parts[3], 10),
      matiere_id: parseInt(parts[5], 10),
      type: parts[7],
      quan: parts[9],
      group_id: parseInt(parts[11], 10),
      id: parts[13],
    }
  }

  const handleDragEnd = async result => {
    if (!result.destination) return

    const from = parseDraggableId(result.draggableId)
    const destination = parseDroppableId(result.destination.droppableId)

    try {
      const res = await API.post("emploi/updateemplois", {
        quart_id: destination.quart_id,
        jour_id: destination.jour_id,
        id: from.id,
        user_id,
        annee_id,
      }).then(res => {
        // 🔹 Mise à jour du state jours
        const newJours = JSON.parse(JSON.stringify(jours))

        const sourceDay = newJours.find(j => j.id_jour === from.jour_id)
        const sourceSeance = sourceDay.seances.find(
          s => s.id_quart === from.quart_id
        )
        const movedItem = sourceSeance.options.splice(result.source.index, 1)[0]

        const destDay = newJours.find(j => j.id_jour === destination.jour_id)
        const destSeance = destDay.seances.find(
          s => s.id_quart === destination.quart_id
        )
        destSeance.options.splice(result.destination.index, 0, movedItem)

        setJours(newJours)
        const resE = API.post("emploi/get_by_id", {
          enseignant_id: enseignantId,
          semestre_id: semestre_id,
          annee_id: annee_id,
        }).then(resE => {
          setQuarts(resE.data.emploi[0].quarts)
          setJours(resE.data.emploi[0].jours)
          // setModal(false)
        })
      })
    } catch (error) {
      toast.error("❌ Erreur de connexion à l’API !!", {
        containerId: "A",
      })
    }
  }

  const getColorByType = type => {
    switch (type) {
      case "1":
        return "#ffeded" // rouge clair
      case "2":
        return "#f3fff3" // vert clair
      case "3":
        return "#cce5ff" // bleu clair
      case "4":
        return "#e0e0e0" // gris clair
      default:
        return "#f0f0f0"
    }
  }
  return (
    <Fragment>
      <div className="page-content">
        <Container fluid>
          <Card>
            <CardBody>
              {loading ? (
                <Fragment>
                  <Row>
                    <div
                      style={{
                        display: "flex",
                        fontSize: "13px",
                      }}
                    >
                      <span style={{ paddingRight: "4px" }}>Enseignant:</span>
                      <span style={{ fontWeight: "bold" }}>
                        {enseignantNom}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        fontSize: "13px",
                      }}
                    >
                      <span style={{ paddingRight: "4px" }}>
                        Voeux du jours:
                      </span>
                      {voeuxJour.map((el, index) => (
                        <span
                          key={index}
                          style={{ fontWeight: "bold", paddingLeft: "5px" }}
                        >
                          {el.name} ,
                        </span>
                      ))}
                    </div>
                    <DragDropContext onDragEnd={handleDragEnd}>
                      <table className="table table-bordered text-center">
                        <thead className="table table-light">
                        <tr>
                          <th></th>
                          {quarts.map((el, i) => (
                            <th key={i}>{el.label_quart}</th>
                          ))}
                        </tr>
                        </thead>
                        <tbody>
                        {jours.map((elem, indexJour) => (
                          <tr key={elem.id_jour}>
                            <td>{elem.label_jour}</td>
                            {elem.seances.map((element, indexQuart) => {
                              const droppableId = `jour-${elem.id_jour}-quart-${quarts[indexQuart].id_quart}`

                              return (
                                <td
                                  key={indexQuart}
                                  className="td-emploi"
                                  style={{ padding: 0 }}
                                >
                                  <Droppable droppableId={droppableId}>
                                    {provided => (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.droppableProps}
                                        style={{ minHeight: "80px" }}
                                      >
                                        {element.options?.length > 0 &&
                                        element.options.some(
                                          opt =>
                                            opt.id_matiere !== "" ||
                                            opt.id_group !== "" ||
                                            opt.id_salle !== ""
                                        ) ? (
                                          element.options.map(
                                            (elle, indexOption) => {
                                              const draggableId = `jour-${elem.id_jour}-quart-${quarts[indexQuart].id_quart}-matiere-${elle.id_matiere}-type-${elle.type}-quan-${elle.quan}-group_id-${elle.id_group}-id-${elle.id_seance}`
                                              return (
                                                <Draggable
                                                  key={draggableId}
                                                  draggableId={draggableId}
                                                  index={indexOption}
                                                >
                                                  {provided => (
                                                    <div
                                                      ref={provided.innerRef}
                                                      {...provided.draggableProps}
                                                      {...provided.dragHandleProps}
                                                      style={{
                                                        userSelect: "none",
                                                        padding: 8,
                                                        margin: "4px 0",
                                                        backgroundColor:
                                                          getColorByType(
                                                            elle.type
                                                          ),
                                                        position: "relative", // 🔑 pour positionner l’icône
                                                        ...provided
                                                          .draggableProps
                                                          .style,
                                                      }}
                                                    >
                                                      <p
                                                        style={{
                                                          textAlign: "center",
                                                        }}
                                                      >
                                                        {elle.label_matiere}
                                                      </p>
                                                      <p
                                                        style={{
                                                          textAlign: "center",
                                                        }}
                                                      >
                                                        {elle.label_group}
                                                      </p>
                                                      <p
                                                        style={{
                                                          textAlign: "center",
                                                        }}
                                                      >
                                                        {elle.label_salle}
                                                      </p>
                                                      <div
                                                        onClick={() =>
                                                          open(elle)
                                                        }
                                                        className="icon_remove"
                                                      >
                                                        <i
                                                          style={{
                                                            color: "red",
                                                            cursor: "pointer",
                                                          }}
                                                          className="far fa-trash-alt"
                                                        ></i>
                                                      </div>
                                                      {element.quan == 1 ? (
                                                        <div className="icon_quan"></div>
                                                      ) : null}
                                                    </div>
                                                  )}
                                                </Draggable>
                                              )
                                            }
                                          )
                                        ) : (
                                          <td className="td-emploi">
                                            <div className="div-emploi">
                                              <button
                                                onClick={() =>
                                                  toggle(
                                                    element,
                                                    elem.id_jour
                                                  )
                                                }
                                                type="button"
                                                className="btn btn-info btn-link btn-just-icon btn-sm text-white"
                                                title="Ajouter Séance"
                                              >
                                                <i className="fas fa-plus"></i>
                                              </button>
                                            </div>
                                          </td>
                                        )}
                                        {provided.placeholder}
                                      </div>
                                    )}
                                  </Droppable>
                                </td>
                              )
                            })}
                          </tr>
                        ))}
                        </tbody>
                      </table>
                    </DragDropContext>
                  </Row>
                  <Row>
                    <div
                      className="mt-4"
                      style={{ display: "flex", justifyContent: "center" }}
                    >
                      <Button
                        type="button"
                        color="warning"
                        className="btn btn-warning  mb-2 me-2"
                        onClick={() =>
                          props.history.push("/SchedulesEnseignants")
                        }
                      >
                        Annuler
                      </Button>

                      {colture === 0 || colture === "" ? (
                        <Button
                          type="button"
                          color="success"
                          className="btn btn-success  mb-2 me-2"
                          onClick={cloturer}
                        >
                          Clôturer
                        </Button>
                      ) : null}
                      {(user_id === 13 || user_id === 8) &&
                      (colture === 1 || colture === "1") ? (
                        <Button
                          type="button"
                          color="danger"
                          className="btn btn-warning  mb-2 me-2"
                          onClick={cloturer}
                        >
                          Déclôturer
                        </Button>
                      ) : null}
                      <button
                        type="button"
                        style={{
                          backgroundColor: "#761C19",
                          borderColor: "#761C19",
                        }}
                        className="btn btn-success mb-2 me-2"
                        onClick={ValiderEmploi}
                      >
                        {"Valider l'emploi"}
                      </button>
                    </div>
                  </Row>
                </Fragment>
              ) : (
                <div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    {" "}
                    <Spinner type="grow" className="ms-6" color="primary" />
                  </div>
                  <h4
                    style={{ textAlign: "center", marginTop: "2%" }}
                    className="ms-6"
                  >
                    {" "}
                    {"Chargement"} ...{" "}
                  </h4>
                </div>
              )}
            </CardBody>
          </Card>
          <ToastContainer
            transition={Slide}
            enableMultiContainer
            containerId={"A"}
            position={toast.POSITION.TOP_RIGHT}
            autoClose={2500}
          />
        </Container>
      </div>
      <Modal size="xl" isOpen={modal} toggle={toggle} centered={true}>
        <ModalHeader style={{ width: "100% !important", textAlign: "center !important"}} toggle={toggle} tag="h4">
          Ajouter Séance
        </ModalHeader>
        <ModalBody>
          {loadingAdd ? (
            <div>
              {array.map((element, index) => (
                <Fragment key={index}>
                  <Row>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">Type</Label>
                        <Select
                          options={type}
                          isSearchable={true}
                          value={element.type_matiere}
                          onChange={e => getMatiere(e, index)}
                        />
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="form-check mt-5">
                        <Input
                          type="checkbox"
                          className="form-check-Input"
                          id="formrow-customCheck"
                          checked={
                            etatQuanzaine == 1
                          }
                          disabled={quan == 1}
                          onClick={e => setQuanzaine(e, index)}
                        />
                        <Label
                          className="form-check-Label"
                          htmlFor="formrow-customCheck"
                        >
                          1/2 groupe
                        </Label>
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">Matiere</Label>
                        <Select
                          options={matiere}
                          isSearchable={true}
                          value={element.matiere_id}
                          onChange={e => getGroupe1(e, index)}
                        />
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          Nbr heure
                        </Label>
                        <Input
                          lg="3"
                          className="form-control"
                          placeholder="nbr heure"
                          type="text"
                          value={element.charge_matiere}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="3">
                      <div className="mb-3">
                        <Label className="d-block mb-3">Choix des salles :</Label>
                        <div className="form-check form-check-inline">
                          <Input
                            type="radio"
                            id="customRadioInline1"
                            name="customRadioInline1"
                            className="form-check-input"
                            checked={tousSalle === 1}
                            onChange={e => TousSalle(1)}
                            disabled={quan != 1}
                          />
                          <Label
                            className="form-check-label"
                            htmlFor="customRadioInline1"
                          >
                            Tous Salles
                          </Label>
                        </div>
                        &nbsp; &nbsp; &nbsp;&nbsp;
                        <div className="form-check form-check-inline">
                          <Input
                            type="radio"
                            id="customRadioInline2"
                            name="customRadioInline1"
                            className="form-check-input"
                            checked={tousSalle === 2}
                            onChange={e => filterSalle(2)}
                            disabled={quan != 1}
                            // disabled={isReadOnly}
                          />
                          <Label
                            className="form-check-label"
                            htmlFor="customRadioInline2"
                          >
                            Filtrer Salles
                          </Label>
                        </div>
                      </div>
                    </Col>
                    {element.charge_matiere >= 42 ? (
                        <Col lg="3">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">Nbr heure seance</Label>
                            <Select
                              options={nbrHeureSeance}
                              isSearchable={true}
                              value={element.nbrHeureSeance}
                              onChange={e => getNbHeureSeance(e, index)}
                            />
                          </div>
                        </Col>
                      ):
                      <Col lg="3">
                        <div className="mb-3">
                          <Label for="basicpill-firstname-input1"></Label>

                        </div>
                      </Col>
                    }

                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">Salle</Label>
                        <Select
                          options={salle}
                          isSearchable={true}
                          value={element.salle_id}
                          onChange={e => getGroupe(e, index)}
                        />
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          Capacité salle
                        </Label>
                        <Input
                          lg="3"
                          className="form-control"
                          placeholder="nbr heure"
                          type="text"
                          value={element.capacite_salle}
                        />
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <div className="mb-3">
                        <Label className="d-block mb-3">Choix de capacité pour les matières option :</Label>
                        <div className="form-check form-check-inline">
                          <Input
                            type="radio"
                            id={`customRadioInline1-${index}`}
                            name={`customRadioInline-${index}`}
                            className="form-check-input"
                            value={1}
                            checked={element.capacite === 1}   // contrôle via state
                            defaultChecked={index === 0}       // coché par défaut pour la 1ère ligne
                            onChange={(e) => CheckCapacite(parseInt(e.target.value), index)}
                          />

                          <Label className="form-check-label" htmlFor={`customRadioInline1-${index}`}>
                            Avec condition de capacité
                          </Label>
                        </div>
                        &nbsp; &nbsp; &nbsp;&nbsp;
                        <div className="form-check form-check-inline">
                          <Input
                            type="radio"
                            id={`customRadioInline2-${index}`}
                            name={`customRadioInline-${index}`}
                            className="form-check-input"
                            checked={element.capacite === 2}
                            value={2}
                            // disabled={disabled}
                            onChange={(e) => CheckCapacite(2, index)}
                          />
                          <Label className="form-check-label" htmlFor={`customRadioInline2-${index}`}>
                            Sans condition de capacité
                          </Label>

                        </div>
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">Groupe</Label>
                        <Select
                          options={groupe}
                          isSearchable={true}
                          isMulti={true}
                          value={element.group_id}
                          onChange={e => addGroupe(e, index)}
                        />
                      </div>
                    </Col>
                    <Col lg="3">
                      <div className="mb-3">
                        <Label for="basicpill-firstname-input1">
                          Capacité groupe
                        </Label>
                        <Input
                          lg="3"
                          className="form-control"
                          placeholder="nbr heure"
                          type="text"
                          value={element.capacite_groupe}
                        />
                      </div>
                    </Col>
                  </Row>
                  <div style={{display: "flex", justifyContent: "center"}}>
                    <i
                      style={{
                        color: "#a0ceb8",
                        cursor: "pointer",
                        paddingTop: "5px",
                      }}
                      className="fas fa-plus font-size-18"
                      onClick={addLigne}
                    />
                    {array.length > 1 ? (
                      <i
                        style={{color: "#cc0000"}}
                        className="mdi mdi-delete font-size-18"
                        id="deletetooltip"
                        onClick={() => toggleLigne(index)}
                      />
                    ) : null}
                  </div>
                </Fragment>
              ))}
              <Row>
                <div style={{display: "flex", justifyContent: "center"}}>
                  {" "}
                  <Col lg="6">
                    <div className="text-center mt-4">
                      <button
                        type="button"
                        className="btn btn-primary "
                        onClick={save}
                      >
                        CONFIRMER
                      </button>
                    </div>
                  </Col>
                </div>
              </Row>
            </div>
          ) : (
            <div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {" "}
                <Spinner type="grow" className="ms-6" color="primary" />
              </div>
              <h4
                style={{ textAlign: "center", marginTop: "2%" }}
                className="ms-6"
              >
                {" "}
                {"Chargement"} ...{" "}
              </h4>
            </div>
          )}
        </ModalBody>
      </Modal>
      <Modal isOpen={modalDelete} toggle={open} centered={true}>
        <ModalHeader toggle={open} tag="h4">
          {" Suppression d'une seance"}{" "}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>Voulez-vous supprimer cette seance ?</p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  onClick={deleteSeance}
                  color="info"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  Oui
                </Button>
              </div>
              <div>
                <Button onClick={open} color="danger" className="btn-rounded ">
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  Non
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal style={{ maxWidth: "300px", width: "100%", }} isOpen={modalUpdate} toggle={openModal1} centered={true}>
        <ModalHeader
          style={{
            width: "100% !important",
            textAlign: "center !important",
          }}
          toggle={openModal1}
          tag="h4"
        >
          Update Séance
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col lg="12">
              <div className="mb-6">
                <Label for="basicpill-firstname-input1">Salle</Label>
                <Select
                  options={salle}
                  isSearchable={true}
                  value={selectSalle}
                  onChange={e => setSelectSalle(e)}
                />
              </div>
            </Col>
            {/*<Col lg="6">*/}
            {/*  <div className="mb-3">*/}
            {/*    <Label for="basicpill-firstname-input1">Groupe</Label>*/}
            {/*    <Select*/}
            {/*      options={groupe}*/}
            {/*      isSearchable={true}*/}
            {/*      value={selectGroupe}*/}
            {/*      onChange={e => setSelectGroupe(e)}*/}
            {/*    />*/}
            {/*  </div>*/}
            {/*</Col>*/}
          </Row>
          <Row>
            <div style={{ display: "flex", justifyContent: "center" }}>
              {" "}
              <Col lg="6">
                <div className="text-center mt-4">
                  <button
                    type="button"
                    className="btn btn-primary "
                    onClick={edit}
                  >
                    CONFIRMER
                  </button>
                </div>
              </Col>
            </div>
          </Row>
        </ModalBody>
      </Modal>
      <Modal isOpen={modalLigne} toggle={toggleLigne} centered={true}>
        <ModalHeader toggle={toggleLigne} tag="h4">
          {" Suppression d'une ligne"}{" "}
        </ModalHeader>
        <ModalBody>
          <div
            style={{
              fontFamily: "Montserrat, sans-serif",
              FontSize: "14px",
              FontWeight: "700",
              LineHeight: "18.375px",
            }}
          >
            <div style={{ display: "flex", justifyContent: "center" }}>
              <p>Voulez-vous supprimer cette ligne ?</p>
            </div>
            <div
              className="hvr-push"
              style={{
                display: "flex",
                justifyContent: "space-around",
                marginBottom: "15px",
              }}
            >
              <div>
                <Button
                  onClick={toggleDeleteLigne}
                  color="info"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-up"
                  ></i>
                  Oui
                </Button>
              </div>
              <div>
                <Button
                  onClick={toggleLigne}
                  color="danger"
                  className="btn-rounded "
                >
                  <i
                    style={{ color: "white" }}
                    className="far fa-thumbs-down"
                  ></i>
                  Non
                </Button>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </Fragment>
  )
}

export default AddScheduleEnseignant
AddScheduleEnseignant.propTypes = {
  history: PropTypes.object,
}
